export enum CredReqEventStatus {
  RequestSubmitted = 'RequestSubmitted',
  RequestInProgress = 'RequestInProgress',
  AdditionalInformationRequested = 'AdditionalInformationRequested',
  SecondAttemptMissingInfo = 'SecondAttemptMissingInfo',
  ThirdAttemptMissingInfo = 'ThirdAttemptMissingInfo',
  AdditionalInformationSubmitted = 'AdditionalInformationSubmitted',
  CancellationRequested = 'CancellationRequested',
  Completed = 'Completed',
  CompletedWithConcern = 'CompletedWithConcern',
  UnableToComplete = 'UnableToComplete',
  Cancelled = 'Cancelled'
}

export const CredReqEventStatusLabel: ObjectType<string> = {
  RequestSubmitted: 'Request Submitted',
  RequestInProgress: 'In Progress',
  AdditionalInformationRequested: 'Additional Info Needed (1st attempt)',
  SecondAttemptMissingInfo: 'Additional Info Needed (2nd attempt)',
  ThirdAttemptMissingInfo: 'Additional Info Needed (3rd attempt)',
  AdditionalInformationSubmitted: 'Additional Information Submitted',
  Completed: 'Completed',
  CompletedWithConcern: 'Completed - Concern',
  UnableToComplete: 'Unable to Complete',
  CancellationRequested: 'Cancellation Requested',
  Cancelled: 'Cancelled'
};

export const CvoAdditionalInfoRequestedStatusList = [
  CredReqEventStatus.AdditionalInformationRequested,
  CredReqEventStatus.SecondAttemptMissingInfo,
  CredReqEventStatus.ThirdAttemptMissingInfo
];

export const DefaultActiveCredentialingStatusList = [
  CredReqEventStatus.RequestSubmitted,
  CredReqEventStatus.RequestInProgress,
  ...CvoAdditionalInfoRequestedStatusList,
  CredReqEventStatus.AdditionalInformationSubmitted,
  CredReqEventStatus.CancellationRequested
];

export const CompletedCvoStatusList = [
  CredReqEventStatus.Cancelled,
  CredReqEventStatus.Completed,
  CredReqEventStatus.CompletedWithConcern,
  CredReqEventStatus.UnableToComplete
];

/**
 * Credentailing status only mapped for completed cvo event status
 */
export const MapCredEventStatusWithCredentialingStatus: ObjectType<string> = {
  [CredReqEventStatus.Completed]: 'Credentialing Packet',
  [CredReqEventStatus.CompletedWithConcern]: 'Credentialing Packet - Concern'
};

export const getCredReqEventStatusAsList = (
  ignoreStatuses?: CredReqEventStatus[]
): CommonList[] => {
  return Object.values(CredReqEventStatus)
    .filter((status) => !ignoreStatuses?.includes(status))
    .map((status) => ({
      id: status,
      label: CredReqEventStatusLabel[status]
    }));
};

export default CredReqEventStatus;
